<template>
  <div class="container mt-4">
     <!-- Breadcrumb -->
     <b-breadcrumb class="m-3">
      <b-breadcrumb-item href="/"> <i class="fa fa-home" aria-hidden="true"></i> Home</b-breadcrumb-item>
      <b-breadcrumb-item href="/residentslist-vit"> Residents</b-breadcrumb-item>
      <b-breadcrumb-item active> {{ getBread("-vit") }}</b-breadcrumb-item>
    </b-breadcrumb>
    <div class="customCard">
      <h1 style="font-size: 2rem; text-align: center; padding-bottom: 1rem">
        List of Vitals {{ fullName }}
      </h1>
    </div>

    <div v-if="loading" class="text-center">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div v-else-if="error" class="text-center text-danger">
      <p>Error loading data.</p>
    </div>
    <div v-else>
      <div v-if="getUserRole('admins')">
      <button class="btn btn-primary mb-4" @click="showAddModal = true">
        Add Vital
      </button>
    </div>
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">Vital Type</th>
            <th scope="col">Value</th>
            <th scope="col">Recorded Date</th>
            <th scope="col" v-if="getUserRole('admins') || getUserRole('editors')">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="vital in paginatedVitals" :key="vital.id">
            <td>
              <a href="#" @click.prevent="viewEntry(vital)">
              {{ getVitalTypeText(vital.attributes.vitaltype) }}
            </a>
            </td>
            <td v-if="isBowel(vital.attributes.vitaltype)">
            {{ 
            getActivityTypes(vital.attributes.activitytype)
            }}
            | 
            {{ 
            getConsistencyTypes(vital.attributes.consistencytype)
            }}
            | 
            {{ 
            getContinenceTypes(vital.attributes.continencetype)
            }}
            | 
            {{ 
            getSizeTypes(vital.attributes.sizetype)
            }}
            | 
            {{ 
            getWitnessTypes(vital.attributes.witnesstype)
            }}
          </td>
            <td v-else-if="isSleep(vital.attributes.vitaltype)">{{ formatDateTimeNormal(new Date(vital.attributes.startdate)) }}
            to {{ formatDateTimeNormal(new Date(vital.attributes.enddate)) }}
            </td>
            <td v-else>{{ vital.attributes.value}}</td>
            <td>
              {{
                formatDateTimeNormal(new Date(vital.attributes.daterecorded))
              }}
            </td>
            <td v-if="getUserRole('admins') || getUserRole('editors')"><a href="#" @click.prevent="editEntry(vital)">Edit</a></td>
          </tr>
        </tbody>
      </table>
      <div class="d-flex justify-content-between align-items-center">
        <p>
          Showing {{ startIndex + 1 }} to {{ endIndex }} of
          {{ result.residentvitals.data.length }} entries
        </p>
        <ul class="pagination">
          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <a
              class="page-link"
              href="#"
              @click.prevent="changePage(currentPage - 1)"
              >Prev</a
            >
          </li>
          <li
            class="page-item"
            v-for="page in totalPages"
            :key="page"
            :class="{ active: currentPage === page }"
          >
            <a class="page-link" href="#" @click.prevent="changePage(page)">{{
              page
            }}</a>
          </li>
          <li
            class="page-item"
            :class="{ disabled: currentPage === totalPages }"
          >
            <a
              class="page-link"
              href="#"
              @click.prevent="changePage(currentPage + 1)"
              >Next</a
            >
          </li>
        </ul>
      </div>
    </div>

    <!-- Edit Modal -->
    <b-modal size="xl" v-model="showEditModal" hide-footer :title="'Edit Vital ' + fullName">
      <form v-if="currentVital" @submit.prevent="updateEntry">
        <div class="row">
          <div class="col-md-4">
            <div class="mb-3">
              <label for="vitaltype" class="form-label">Vital Type</label>
              <div class="input-group">
                <select
                  class="form-select"
                  id="vitaltype"
                  v-model="currentVital.attributes.vitaltype"
                  required
                >
                  <option
                    v-for="option in vitalTypes"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select>
                <div v-if="showUnit" class="input-group-append">
                  <span class="input-group-text">{{ unit }}</span>
                </div>
              </div>
            </div>
            <div v-if="isSleep(currentVital.attributes.vitaltype)">
              <div class="mb-3">
                <label for="startdate" class="form-label">Start Date</label>
                <input
                  type="datetime-local"
                  class="form-control"
                  id="startdate"
                  v-model="formattedStartDate"
                  required
                />
              </div>
              <div class="mb-3">
                <label for="enddate" class="form-label">End Date</label>
                <input
                  type="datetime-local"
                  class="form-control"
                  id="enddate"
                  v-model="formattedEndDate"
                  required
                />
              </div>
            </div>
            <div v-if="isBowel(currentVital.attributes.vitaltype)">
              <div class="mb-3">
                <label for="activitytype" class="form-label"
                  >Activity Type</label
                >
                <select
                  class="form-select"
                  id="activitytype"
                  v-model="currentVital.attributes.activitytype"
                  required
                >
                  <option
                    v-for="option in activityTypes"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select>
              </div>
              <div class="mb-3">
                <label for="consistencytype" class="form-label"
                  >Consistency</label
                >
                <select
                  class="form-select"
                  id="consistencytype"
                  v-model="currentVital.attributes.consistencytype"
                  required
                >
                  <option
                    v-for="option in consistencyTypes"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div v-if="showBowel">
              <div class="mb-3">
                <label for="continencetype" class="form-label"
                  >Continence Satatus</label
                >
                <select
                  class="form-select"
                  id="continencetype"
                  v-model="currentVital.attributes.continencetype"
                  required
                >
                  <option
                    v-for="option in continenceTypes"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select>
              </div>
              <div class="mb-3">
                <label for="witnesstype" class="form-label">Witness</label>
                <select
                  class="form-select"
                  id="witnesstype"
                  v-model="currentVital.attributes.witnesstype"
                  required
                >
                  <option
                    v-for="option in witnessTypes"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </div>
            <div v-if="!isBowel(currentVital.attributes.vitaltype) && !isSleep(currentVital.attributes.vitaltype)">
              <div class="mb-3">
                <label for="value" class="form-label">Value</label>
                <input
                  type="text"
                  class="form-control"
                  id="value"
                  v-model="currentVital.attributes.value"
                  required
                />
              </div>
            </div>
            <div class="mb-3">
              <label for="note" class="form-label">Note</label>
              <textarea
                class="form-control"
                id="note"
                v-model="currentVital.attributes.note"
              ></textarea>
            </div>
          </div>
          <div class="col-md-4">
            <div v-if="showBowel">
              <div class="mb-3">
                <label for="sizetype" class="form-label"
                  >Size</label
                >
                <select
                  class="form-select"
                  id="sizetype"
                  v-model="currentVital.attributes.sizetype"
                  required
                >
                  <option
                    v-for="option in sizeTypes"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select>
              </div>
              </div>
            <div class="mb-3">
              <label for="daterecorded" class="form-label">Recorded Date</label>
              <input
                type="datetime-local"
                class="form-control"
                id="daterecorded"
                v-model="formattedDateRecorded"
              />
            </div>
          </div>
          <div class="d-grid">
            <button type="submit" class="btn btn-primary">Save Changes</button>
          </div>
        </div>
      </form>
      <div v-if="updateError" class="alert alert-danger mt-3">
        {{ updateError }}
      </div>
    </b-modal>

    <!-- View Modal -->
    <b-modal size="xl" v-model="showViewModal" hide-footer title="View Vital">
      <form v-if="currentVital">
        <div class="row">
          <div class="col-md-4">
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Vital Type:</strong>
              <span> {{ getVitalTypeText(currentVital.attributes.vitaltype) }}</span>
            </div>
            <div v-if="isSleep(currentVital.attributes.vitaltype)">
              <div class="mb-3 d-flex flex-row align-items-center">
                <strong class="me-2">Start Date:</strong>
                {{ formatDateTimeNormal(formattedStartDate) }}                  
              </div>
              <div class="mb-3 d-flex flex-row align-items-center">
                <strong class="me-2">End Date:</strong>
              <span> {{ formatDateTimeNormal(formattedEndDate) }} </span>
              </div>
            </div>
            <div v-if="isBowel(currentVital.attributes.vitaltype)">
              <div class="mb-3 d-flex flex-row align-items-center">
                <strong class="me-2">Activity Type:</strong>
               <span>{{ getActivityTypes(currentVital.attributes.activitytype) }}</span>                  
              </div>
              <div class="mb-3 d-flex flex-row align-items-center">                
                <strong class="me-2"> Consistency:</strong>
                <span>  {{ getConsistencyTypes(currentVital.attributes.consistencytype) }} </span>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div v-if="showBowel">
              <div class="mb-3 d-flex flex-row align-items-center">
                <strong class="me-2">Continence Status:</strong>
                <span> {{ getContinenceTypes(currentVital.attributes.continencetype) }}    </span>              
              </div>
              <div class="mb-3 d-flex flex-row align-items-center">
                <strong class="me-2"> Witness:</strong>
                <span> {{ getWitnessTypes(currentVital.attributes.witnesstype) }}</span>
              </div>
            </div>
            <div v-if="!isBowel(currentVital.attributes.vitaltype) && !isSleep(currentVital.attributes.vitaltype)">
              <div class="mb-3 d-flex flex-row align-items-center">
                <strong class="me-2">Value:</strong>
                <span> {{ currentVital.attributes.value }}   </span>               
              </div>
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Note:</strong>
              <span>  {{ currentVital.attributes.note }}</span>
            </div>
          </div>
          <div class="col-md-4">
            <div v-if="showBowel">
              <div class="mb-3 d-flex flex-row align-items-center">
                <strong class="me-2">Size:</strong>
                <span> {{ getSizeTypes(currentVital.attributes.sizetype) }}  </span>                
              </div>
              </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Recorded Date:</strong>
              <span> {{ formatDateTimeNormal(formattedDateRecorded) }}</span>
              
            </div>
          </div>        
        </div>
      </form>
    </b-modal>

    <!-- Add Modal -->
    <b-modal size="xl" v-model="showAddModal" hide-footer :title="'Add Vital ' + fullName"> 
      <form @submit.prevent="addEntry">
        <div class="row">
          <div class="col-md-4">
            <div class="mb-3">
              <label for="vitaltype" class="form-label">Vital Type</label>
              <div class="input-group">
                <select
                  class="form-select"
                  id="vitaltype"
                  v-model="newVital.vitaltype"
                  required
                >
                  <option
                    v-for="option in vitalTypes"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select>
                <div v-if="showUnit" class="input-group-append">
                  <span class="input-group-text">{{ unit }}</span>
                </div>
              </div>
            </div>
            <div v-if="showSleep">
              <div class="mb-3">
                <label for="startdate" class="form-label">Start Date</label>
                <input
                  type="datetime-local"
                  class="form-control"
                  id="startdate"
                  v-model="newVital.startdate"
                  required
                />
              </div>
              <div class="mb-3">
                <label for="enddate" class="form-label">End Date</label>
                <input
                  type="datetime-local"
                  class="form-control"
                  id="enddate"
                  v-model="newVital.enddate"
                  required
                />
              </div>
            </div>
            <div v-if="showBowel">
              <div class="mb-3">
                <label for="activitytype" class="form-label"
                  >Activity Type</label
                >
                <select
                  class="form-select"
                  id="activitytype"
                  v-model="newVital.activitytype"
                  required
                >
                  <option
                    v-for="option in activityTypes"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select>
              </div>
              <div class="mb-3">
                <label for="consistencytype" class="form-label"
                  >Consistency</label
                >
                <select
                  class="form-select"
                  id="consistencytype"
                  v-model="newVital.consistencytype"
                  required
                >
                  <option
                    v-for="option in consistencyTypes"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div v-if="showBowel">
              <div class="mb-3">
                <label for="continencetype" class="form-label"
                  >Continence Satatus</label
                >
                <select
                  class="form-select"
                  id="continencetype"
                  v-model="newVital.continencetype"
                  required
                >
                  <option
                    v-for="option in continenceTypes"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select>
              </div>
              <div class="mb-3">
                <label for="witnesstype" class="form-label">Witness</label>
                <select
                  class="form-select"
                  id="witnesstype"
                  v-model="newVital.witnesstype"
                  required
                >
                  <option
                    v-for="option in witnessTypes"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </div>
            <div v-if="!showBowel && !showSleep">
              <div class="mb-3">
                <label for="value" class="form-label">Value</label>
                <input
                  type="text"
                  class="form-control"
                  id="value"
                  v-model="newVital.value"
                  required
                />
              </div>
            </div>
            <div class="mb-3">
              <label for="note" class="form-label">Note</label>
              <textarea
                class="form-control"
                id="note"
                v-model="newVital.note"
              ></textarea>
            </div>
          </div>
          <div class="col-md-4">
            <div v-if="showBowel">
              <div class="mb-3">
                <label for="sizetype" class="form-label"
                  >Size</label
                >
                <select
                  class="form-select"
                  id="sizetype"
                  v-model="newVital.sizetype"
                  required
                >
                  <option
                    v-for="option in sizeTypes"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select>
              </div>
              </div>
            <div class="mb-3">
              <label for="daterecorded" class="form-label">Recorded Date</label>
              <input
                type="datetime-local"
                class="form-control"
                id="daterecorded"
                v-model="newVital.daterecorded"
              />
            </div>
          </div>
          <div class="d-grid">
            <button type="submit" class="btn btn-primary">Add vital</button>
          </div>
        </div>
      </form>
      <div v-if="addError" class="alert alert-danger mt-3">
        {{ addError }}
      </div>
    </b-modal>
  </div>
</template>
  
  <script>
import { useQuery, useMutation } from "@vue/apollo-composable";
import { GET_VITALS_BY_RESIDENT, UPDATE_VITAL, CREATE_VITAL, GET_FULLNAME_BY_ID } from "../hooks/queries";
import { ref, computed } from "vue";
import {
  vitalTypes,
  sizeTypes,
  activityTypes,
  consistencyTypes,
  continenceTypes,
  witnessTypes,
  formatDateTime,
  formatDateTimeNormal,
  getBread,
  getUserRole,
} from "../components/values";
import { useRoute } from 'vue-router'; // Import useRoute from Vue Router  

export default {
  name: "App", 
  setup() {
    const route = useRoute(); // Use useRoute to get the current route
    const residentId = route.params.id; // Access the route parameter directly
    const { result:result, loading:loading, error:error, refetch:refetch } = useQuery(GET_VITALS_BY_RESIDENT, {residentId: residentId});
    const { mutate: updateResidentvital } = useMutation(UPDATE_VITAL);
    const { mutate: createVital } = useMutation(CREATE_VITAL);
    const currentVital = ref(null);
    const updateError = ref(null);
    const addError = ref(null);
    const showEditModal = ref(false);
    const showAddModal = ref(false);
    const showViewModal = ref(false);
    const now = new Date().toISOString().slice(0, 16); // Current date and time in ISO format without seconds


    const {result:resultfullname, loading:loadingfullname, error:errorfullname, refetch:refetchfullname } = useQuery(GET_FULLNAME_BY_ID, {
      id: residentId,
    });

      // Watch the result and compute the full name only when the data is available
      const fullName = computed(() => {
      const data = resultfullname.value?.resident?.data;
      if (data) {
        return `(${data.attributes.firstname} ${data.attributes.lastname})`;
      }
      return null;
    });


    const newVital = ref({
      vitaltype: "",
      value: "",
      note: "",
      daterecorded: now,
      startdate: now,
      enddate: now,
      sizetype: "",
      witnesstype: "",
      activitytype: "",
      continencetype: "",
      consistencytype: "",
      publishedAt: new Date().toISOString(),
    });

    const addEntry = async () => {
      addError.value = null;
      try {
        await createVital({
          data: {
            resident: residentId, // Include the residentId in the input data
            vitaltype: newVital.value.vitaltype,
            value: newVital.value.value,
            note: newVital.value.note,
            daterecorded: formatDateTime(newVital.value.daterecorded),
            startdate: formatDateTime(newVital.value.startdate),
            enddate: formatDateTime(newVital.value.enddate),
            sizetype: newVital.value.sizetype,
            witnesstype: newVital.value.witnesstype,
            activitytype: newVital.value.activitytype,
            continencetype: newVital.value.continencetype,
            consistencytype: newVital.value.consistencytype,
            publishedAt: new Date().toISOString(),
          },
        });
        showAddModal.value = false;
        newVital.value = {
          vitaltype: "",
          value: "",
          note: "",
          daterecorded: now,
          startdate: now,
          enddate: now,
          sizetype: "",
          witnesstype: "",
          activitytype: "",
          continencetype: "",
          consistencytype: "",
        };
        await refetch(); // Refetch the list of vitals after adding a new one
        await refetchfullname();
      } catch (e) {
        //console.error("Error adding entry:", e);
        addError.value = `Failed to add vital. Please try again.}`;
      }
    };

    const formatDate = (date) => {
      const options = { year: "numeric", month: "long", day: "numeric" };
      return new Date(date).toLocaleDateString(undefined, options);
    };
    
   
    const editEntry = (vital) => {
      //currentVital.value = { ...vital }; // Copy vital to avoid directly modifying the original data
      currentVital.value = JSON.parse(JSON.stringify(vital)); // Create a deep copy of the docuement object
      showEditModal.value = true;
    };

    const updateEntry = async () => {
      updateError.value = null; // Reset the error message
      try {
        await updateResidentvital({
          id: currentVital.value.id,
          data: {
            vitaltype: currentVital.value.attributes.vitaltype,
            value: currentVital.value.attributes.value,
            note: currentVital.value.attributes.note,
            daterecorded: formatDateTime(currentVital.value.attributes.daterecorded),
            startdate: formatDateTime(currentVital.value.attributes.startdate),
            enddate: formatDateTime(currentVital.value.attributes.enddate),
            sizetype: currentVital.value.attributes.sizetype,
            witnesstype: currentVital.value.attributes.witnesstype,
            activitytype: currentVital.value.attributes.activitytype,
            continencetype: currentVital.value.attributes.continencetype,
            consistencytype: currentVital.value.attributes.consistencytype,
          },
        });
        //console.log("Updated entry:", currentVital.value);
        showEditModal.value = false;
      } catch (error) {
        //console.error("Error updating entry:", error);
        updateError.value = "Failed to update Vital. Please try again.";
      }
    };

    const viewEntry = (vital) => {
      currentVital.value = JSON.parse(JSON.stringify(vital)); // Create a deep copy of the vital object
      showViewModal.value = true;
    };

    const isSleep = (value) => {
      const option = vitalTypes.find((option) => option.value === value);
      return  option.showSleep;
    };

    const isBowel = (value) => {
      const option = vitalTypes.find((option) => option.value === value);
      return  option.showBowel;
    };


    const getVitalTypeText = (value) => {
      const option = vitalTypes.find((option) => option.value === value);
      return option ? option.text : "";
    };

    const getSizeTypes = (value) => {
      const option = sizeTypes.find((option) => option.value === value);
      return option ? option.text : "";
    };

    const getActivityTypes = (value) => {
      const option = activityTypes.find((option) => option.value === value);
      return option ? option.text : "";
    };

    const getConsistencyTypes = (value) => {
      const option = consistencyTypes.find((option) => option.value === value);
      return option ? option.text : "";
    };

    const getContinenceTypes = (value) => {
      const option = continenceTypes.find((option) => option.value === value);
      return option ? option.text : "";
    };

    const getWitnessTypes = (value) => {
      const option = witnessTypes.find((option) => option.value === value);
      return option ? option.text : "";
    };

    const showUnit = computed(() => {
      const selectedOption = vitalTypes.find(
        (option) => option.value === newVital.value.vitaltype
      );
      return selectedOption ? selectedOption.showUnit : false;
    });

    const unit = computed(() => {
      const selectedOption = vitalTypes.find(
        (option) => option.value === newVital.value.vitaltype
      );
      return selectedOption ? selectedOption.unit : "";
    });

    const showSleep = computed(() => {
      const selectedOption = vitalTypes.find(
        (option) => option.value === newVital.value.vitaltype
      );
      return selectedOption ? selectedOption.showSleep : false;
    });

    const showBowel = computed(() => {
      const selectedOption = vitalTypes.find(
        (option) => option.value === newVital.value.vitaltype
      );
      return selectedOption ? selectedOption.showBowel : false;
    });

    return {
      result,
      loading,
      error,
      formatDate,
      formatDateTime,
      formatDateTimeNormal,
      showEditModal,
      showAddModal,
      showViewModal,
      currentVital,
      newVital,
      showUnit,
      showSleep,
      showBowel,
      unit,
      editEntry,
      viewEntry,
      updateEntry,
      addEntry,
      updateError,
      addError,
      vitalTypes,
      isSleep,
      isBowel,
      getVitalTypeText,
      getSizeTypes,
      sizeTypes,
      getWitnessTypes,
      witnessTypes,
      activityTypes,
      getActivityTypes,
      consistencyTypes,
      getConsistencyTypes,
      continenceTypes,
      getContinenceTypes,
      getBread,
      getUserRole,
      residentId,
      errorfullname,
      loadingfullname,
      fullName,   
    };
  },
  data() {
    return {
      currentPage: 1,
      itemsPerPage: 10,
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(
        this.result.residentvitals.data.length / this.itemsPerPage
      );
    },
    paginatedVitals() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.result.residentvitals.data.slice(
        start,
        start + this.itemsPerPage
      );
    },
    startIndex() {
      return (this.currentPage - 1) * this.itemsPerPage;
    },
    endIndex() {
      return Math.min(
        this.startIndex + this.itemsPerPage,
        this.result.residentvitals.data.length
      );
    },
    /** 
    fullName() {
    let residentFullName = "";
    if (
      this.result &&
      this.result.residentvitals &&
      this.result.residentvitals.data.length > 0
    ) {
      const resident = this.result.residentvitals.data[0].attributes.resident;
      if (resident && resident.data && resident.data.attributes) {
        residentFullName =
          "(" +
          resident.data.attributes.firstname +
          " " +
          resident.data.attributes.lastname +
          ")";
      }
    }
    return residentFullName;
  },
  */

    formattedStartDate: {
      get() {
        return this.formatDateTimeEdit(this.currentVital.attributes.startdate);
      },
      set(newValue) {
        this.currentVital.attributes.startdate = newValue;
      }
    },
    formattedEndDate: {
      get() {
        return this.formatDateTimeEdit(this.currentVital.attributes.enddate);
      },
      set(newValue) {
        this.currentVital.attributes.enddate = newValue;
      }
    },
    formattedDateRecorded: {
      get() {
        return this.formatDateTimeEdit(this.currentVital.attributes.daterecorded);
      },
      set(newValue) {
        this.currentVital.attributes.daterecorded = newValue;
      }
    },
  },
  methods: {
    changePage(page) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
    formatDateTimeEdit(dateTime) {
      // Create a Date object from the input date-time string
      let date = new Date(dateTime);
      
      // Format the date and time to 'YYYY-MM-DDTHH:MM'
      let formattedDate = date.toISOString().slice(0, 16);
      
      return formattedDate;
    }
  },
};
</script>
  
  <style>
.container {
  max-width: 80%;
}

.d-grid {
  background-color: #e8e8e8;
  margin-bottom: 20px;
}

.text-center {
  text-align: center;
}
.spinner-border {
  margin-top: 20px;
}
.pagination {
  margin: 0;
}
</style>
  
